query ApplicationsForDocumentExports {
    applications {
        id
        domain

        name

        brandIDs
    }
}
